import { c as _c } from "react/compiler-runtime";
import { Box } from '@mui/material';
import type { StructuredContentDocument, StructuredContentDocumentWithRenderer } from '../../hydration/types';
import { renderStructuredContent } from '../../renderContext';
export type ContainerProps = StructuredContentDocumentWithRenderer<{
  spacing?: {
    top?: number;
    bottom?: number;
  };
  children: StructuredContentDocument;
}>;
export const Container = t0 => {
  const $ = _c(8);
  const {
    props: t1
  } = t0;
  const {
    children,
    spacing
  } = t1;
  const t2 = spacing?.top;
  const t3 = spacing?.bottom;
  let t4;
  if ($[0] !== t2 || $[1] !== t3) {
    t4 = {
      mt: t2,
      mb: t3
    };
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== children) {
    t5 = renderStructuredContent(children);
    $[3] = children;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t4 || $[6] !== t5) {
    t6 = <Box sx={t4}>{t5}</Box>;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
};